import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [devResetUrl, setDevResetUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setDevResetUrl('');
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/forgot-password', { email: email.trim() });
      setMessage(res.data.message || t('adminLogin.forgotSuccess'));
      if (res.data.devResetUrl) {
        setDevResetUrl(res.data.devResetUrl);
      }
    } catch (err) {
      setError(err.response?.data?.error || t('adminLogin.forgotError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card admin-auth-card">
        <h2>{t('adminLogin.forgotTitle')}</h2>
        <p className="section-desc">{t('adminLogin.forgotLead')}</p>
        {error && <div className="error">{error}</div>}
        {message && <div className="success">{message}</div>}
        {devResetUrl && (
          <div className="admin-dev-reset-url">
            <p className="form-hint">{t('adminLogin.forgotDevHint')}</p>
            <a href={devResetUrl}>{devResetUrl}</a>
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('adminLogin.forgotEmail')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder={t('adminLogin.placeholder')}
              autoComplete="email"
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? t('adminLogin.forgotSending') : t('adminLogin.forgotSubmit')}
          </button>
        </form>
        <p className="admin-auth-back">
          <Link to="/admin/login">{t('adminLogin.backToLogin')}</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
